import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from '../util/EmptyState';

interface Props {
  notices: any[];
}

// Заглушка ленты уведомлений — реальный экран (лента + мини-календарь по концепту)
// разворачивается отдельным шагом. Пока показывает существующие userNotice.
const MobileNotifications: React.FC<Props> = ({ notices }) => {
  const { t } = useTranslation();

  if (!notices || notices.length === 0) {
    return <EmptyState icon="🔔" message={t('NoNotifications') as string} />;
  }

  return (
    <div className="flex flex-col gap-[8px]">
      {notices.map((n: any, i: number) => (
        <div key={n?.id ?? i} className="dt-card-wrap p-[13px]">
          <div className="text-[14px] font-bold text-[var(--text-color)]">
            {n?.title ?? n?.message ?? n?.text ?? '—'}
          </div>
          {(n?.description || n?.body) && (
            <div className="text-[12px] text-[var(--text-color-calendar)] mt-[3px]">
              {n.description ?? n.body}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MobileNotifications;
